import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReceivablesStatement} from "../../../../shared/interface/receivables-statement";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import { ReplaySubject} from "rxjs";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  DictService, RECEIVABLES_IMPORT_ROW_STATUS,
  RECEIVABLES_IMPORT_ROW_STATUS_UNPAID
} from "../../../../shared/services/dict.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {delay, takeUntil, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesStatementService} from "../../../../shared/services/receivables-statement.service";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {SelectionModel} from "@angular/cdk/collections";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {ArrayValidators} from "../../../../shared/validator/array-validators";
import {StatementAddDialogComponent} from "../statement-add-dialog/statement-add-dialog.component";

@Component({
  selector: 'app-statement-add',
  templateUrl: './statement-add.component.html',
  styleUrls: ['./statement-add.component.scss']
})
export class StatementAddComponent implements  OnInit, OnDestroy, AfterViewInit {
  @Input() ofwcaId?: string = null;
  @Input() partnerId?: string = null;
  @Input() receivablesStatement?: ReceivablesStatement;
  @Input() dialogRef?: MatDialogRef<StatementAddDialogComponent>;
  @Input() mod = false;
  @Output() closeModification = new EventEmitter<any>();
  @Output() statementCreated = new EventEmitter<string>();


  initialFilters: any;
  receivablesStatementForm: FormGroup;
  partnerControl: FormControl;
  ofwcaControl: FormControl;
  sumControl: FormControl;
  partnerOfwcaControl: FormControl;
  rowId: string[] = [];
  rowsControl: FormControl;
  rows: ReceivablesImportRow[] = [];
  displayedColumns: string[] = ['select', 'tu', 'nr', 'ofwca', 'conclusionAt', 'customerName', 'sum'];
  processingRequest = false;
  partnerActive = true;
  sortBy = 'createdAt';
  sortOrder = 'desc';
  totalAmountDue = 0;
  selection = new SelectionModel<ReceivablesImportRow>(true, []);
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private authService: AuthService,
    private receivablesStatementService: ReceivablesStatementService,
    private receivablesImportsRowService: ReceivablesImportsRowService
) {
    this.receivablesStatementForm = fb.group({
      partnerOfwca: this.partnerOfwcaControl  = fb.control(null),
      partner: this.partnerControl = fb.control(''),
      ofwca: this.ofwcaControl = fb.control(''),
      rows: this.rowsControl = fb.control([], [ArrayValidators.minLength(1)]),
      sum: this.sumControl = fb.control(0, [Validators.required]),

    });
    this.receivablesImportsRowService.rowListAddSubject
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe({
      next: (response: CountedAndPaginated<ReceivablesImportRow>) => {
        this.rows = response.items;
      },
      error: (response: HttpErrorResponse) => {
        this.snack.open('Przy ładowaniu danych wystąpił błąd', response.status.toString(), {duration: 2000});
      }
    });
  }

  ngOnInit(): void {
    if (this.partnerId){
      this.partnerOfwcaControl.setValue(0);
      this.partnerActive = true;
      this.partnerControl.setValue(this.partnerId);
      this.loadListData();
    }
    if (this.ofwcaId){
      this.partnerOfwcaControl.setValue(0);
      this.partnerActive = false;
      this.ofwcaControl.setValue(this.ofwcaId);
      this.loadListData();
    }
    this.partnerOfwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val) => {
        this.partnerControl.setValue(null);
        this.ofwcaControl.setValue(null);
        this.selection.clear();
        this.totalAmountDue = 0;
        if (val === '1') {
          this.partnerActive = false;
        }
        if (val === '0') {
          this.partnerActive = true;
        }
      });

    this.partnerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val) => {
        if (val && val.length > 0) {
          this.ofwcaControl.setValue(null);
          this.selection.clear();
          this.totalAmountDue = 0;
          this.loadListData();
        }
      });

    this.ofwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val) => {
        if (val && val.length > 0)  {
          this.partnerControl.setValue(null);
          this.selection.clear();
          this.totalAmountDue = 0;
          this.loadListData();
        }
      });

    this.selection.changed.subscribe(change => {
      change.added.forEach(element => {
        this.totalAmountDue += Number(element.amountDue);
      });
      change.removed.forEach(element => {
        this.totalAmountDue -=  Number(element.amountDue);
      });
    });

  }

  ngAfterViewInit(): void {
  //   if (this.addressImportRow) {
  //     this.initialize(this.addressImportRow);
  //   } else {
  //     this.initialized.next(true);
  //   }
  // }
  //
  // initialize(row: AddressImportRow): void {
  //   of(row)
  //     .pipe(
  //       delay(0),
  //       tap(() => {
  //         this.addressImportRowForm.reset({
  //           id: row.id,
  //           name: row.value,
  //           type: row.type.id
  //         });
  //       }),
  //       delay(0),
  //       tap(() => this.initialized.next(true))
  //     ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    if (this.dialogRef)
    {
      this.dialogRef.close();
    } else if (!this.receivablesStatement) {
      this.router.navigate(['/naleznosci/zestawienia/lista/zgloszone_do_rozliczenia']);
    } else {
      this.closeModification.emit();
    }
  }

  sendForm(): void {
    this.processingRequest = true;
    this.selection.selected.forEach((row: ReceivablesImportRow) =>{
      this.rowId.push(row.uuid);
    });
    this.rowsControl.setValue(this.rowId);
    this.sumControl.setValue(this.totalAmountDue);
    if (!this.receivablesStatementForm.valid) {
      this.receivablesStatementForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.receivablesStatementService.sendForm(this.receivablesStatementForm.value)
      .subscribe((response) => {
        this.snack.open(this.receivablesStatement ? 'Pomyślnie zaktualizowano zestawienie' : 'Pomyślnie dodano zestawienia.', '', {
          duration: 2000,
        });
        if (this.receivablesStatement) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/naleznosci/zestawienia/szczegoly', response.uuid]);
        }
        this.processingRequest = false;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas dodawania zestawiena wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        this.processingRequest = false;
      });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.rows.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.rows);
  }

  checkboxLabel(row?: ReceivablesImportRow): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.uuid + 1}`;
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.partnerControl.value) {
      filters.partner = this.partnerControl.value;
    }

    if (null !== this.ofwcaControl.value) {
      filters.ofwca = this.ofwcaControl.value;
    }

    this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS)
      .pipe()
      .subscribe((dictId: number) => {
        filters.status = dictId;
      });

    return filters;
  }

  loadListData(): void {
    this.receivablesImportsRowService.loadListAdd(
      0,
      999999,
      this.buildFilters(),
      '',
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
    );
  }

}
